/*
 * eslint-disable -- o backdrop e uma area de clique invisivel que cobre a
 * pagina. Um WButton traria caixa, fundo e rotulo visiveis.
 */
/* eslint-disable @alice-health/w-button */

import classNames from 'classnames'
import { Drawer } from '@/global/components/Drawer'
import { zIndex } from '@/global/constants/z-index'
import { drawerMenu } from './Navbar.constants'
import { menuDrawerId } from './Navbar.helpers'
import { NavbarDrawerGroup } from './NavbarDrawerGroup'
import { NavbarDrawerSocial } from './NavbarDrawerSocial'

interface NavbarDrawerProps {
  isClosing: boolean
  onClose: () => void
}

const NavbarDrawer = ({ isClosing, onClose }: NavbarDrawerProps) => (
  <Drawer
    id={menuDrawerId}
    fullWidth
    backGroundColor='bg-transparent'
    /*
     * Acima do vidro da barra e abaixo do conteudo do header: o painel cobre a
     * faixa, mas o X e o logo continuam a vista. Em producao a barra tambem fica
     * por cima e o proprio hamburger vira o X que fecha, entao o painel nao
     * repete logo nem botao de fechar.
     */
    className={classNames('inset-0 h-full', zIndex.global.navbarDrawer)}
  >
    {/*
     * O backdrop e um botao para fechar por clique fora tambem no teclado. O
     * cursor volta ao padrao porque nao ha alvo visivel para clicar.
     *
     * Cobre a tela toda, inclusive a faixa do header: em producao a barra
     * fica transparente com o menu aberto e o escurecimento passa por tras
     * dela. So o conteudo do header continua nitido.
     */}
    <button
      type='button'
      aria-label='Fechar o menu'
      data-testid='navbar-drawer-backdrop'
      onClick={onClose}
      className={classNames(
        'absolute inset-0 cursor-default bg-gl-color-transparent-black-30 motion-reduce:animate-none',
        isClosing ? 'animate-fade-out' : 'animate-fade-in'
      )}
    />

    <div
      data-testid='navbar-drawer-panel'
      className={classNames(
        'navbar-drawer-theme absolute flex flex-col',
        /*
         * `navbar-drawer-panel` traz a caixa inteira: folga, largura e raio, que
         * mudam em 992px.
         */
        'navbar-drawer-panel overflow-y-auto bg-gl-color-shades-white',
        /*
         * O painel abre esticando de cima para baixo e o fundo escurece
         * junto, nos 300ms do `transition: all .3s` de producao. No
         * fechamento os dois rodam ao contrario, e so depois disso o `Drawer`
         * desmonta o painel.
         */
        'motion-reduce:animate-none',
        isClosing ? 'animate-conceal-up' : 'animate-reveal-down'
      )}
    >
      {/*
       * 128px no topo e 48px nas laterais em qualquer largura, como o
       * `.n-sidebar_mid` de producao: o recuo nao muda quando o painel passa
       * a ocupar a tela toda.
       */}
      <div className='flex flex-col gap-gl-spacing-16 px-gl-spacing-12 pb-gl-spacing-10 pt-gl-spacing-32'>
        {drawerMenu.map(group => (
          <NavbarDrawerGroup
            key={group.title}
            group={group}
            onNavigate={onClose}
          />
        ))}
      </div>

      <div className='mt-auto px-gl-spacing-12 pb-gl-spacing-10 pt-gl-spacing-10'>
        <NavbarDrawerSocial onNavigate={onClose} />
      </div>
    </div>
  </Drawer>
)

export { NavbarDrawer }
